import { render } from "./AddSmartGoal.vue?vue&type=template&id=2ca91514&scoped=true"
import script from "./AddSmartGoal.vue?vue&type=script&lang=js"
export * from "./AddSmartGoal.vue?vue&type=script&lang=js"

import "./AddSmartGoal.vue?vue&type=style&index=0&id=2ca91514&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca91514"]])

export default __exports__